var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import yoda from '@kibt/bridge';
import React, { useEffect } from 'react';
import { Animated, Text, View } from 'react-native';
import RootSiblings from 'react-native-root-siblings';
import { useAnimateTimming } from '../../hooks/useAnimate';
import { delay } from '../../utils/delay';
import { useToastStyle } from './style';
export function Toast(props) {
    const { visible = false, content, style = null, zIndex = 10000, numberOfLines, maskStyle = null, } = props;
    const { opacity, fadeIn } = useAnimateTimming({ fromVal: 0, toVal: 1 });
    const styles = useToastStyle(zIndex);
    useEffect(() => {
        if (visible) {
            fadeIn();
        }
    }, [visible]);
    return visible ? (React.createElement(Animated.View, { style: [
            styles.nonModelBox,
            {
                opacity: opacity,
            },
            maskStyle,
        ] },
        React.createElement(View, { style: [styles.centeredView, style] },
            React.createElement(View, { style: styles.modalView },
                React.createElement(Text, Object.assign({}, (numberOfLines ? { numberOfLines } : {}), { style: styles.modalText }), content))))) : null;
}
const DefaultDuration = 1500;
Toast.show = function ToastShow(props, options) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
        let p = props;
        if (typeof props === 'string') {
            p = Object.assign({ content: props }, options);
        }
        if ((_a = p === null || p === void 0 ? void 0 : p.useNativeToast) !== null && _a !== void 0 ? _a : true) {
            const { result } = yield yoda.ui.showToast({
                type: 'normal',
                text: p.content || p.text || '',
                isAddToWindow: (_b = p.isAddToWindow) !== null && _b !== void 0 ? _b : true,
                duration: (_c = p.duration) !== null && _c !== void 0 ? _c : DefaultDuration,
            });
            if (result === 1) {
                yield delay((_d = p.duration) !== null && _d !== void 0 ? _d : DefaultDuration);
                return;
            }
        }
        const slibing = new RootSiblings(React.createElement(Toast, Object.assign({}, p, { content: p.text || p.content, visible: true })));
        yield delay((_e = p.duration) !== null && _e !== void 0 ? _e : DefaultDuration);
        slibing.destroy();
    });
};
export default Toast;
